
import  {useState}  from "react";
import {useEffect} from "react";
import { useRef } from 'react';



function SelectedShow(props){



    function convertToDateTime(timeStr, date) {
        console.log("TIme String"+timeStr);
        console.log("Date of selected show" + date);
        if (timeStr.length !== 6) {
            throw new Error("Invalid time format. Expected HHMMSS.");
        }
    
        // Extract hours, minutes, and seconds from the string

        let year = parseInt(date.substring(0, 4), 10);
        let month = parseInt(date.substring(4, 6), 10);
        let day = parseInt(date.substring(6, 8), 10);
        console.log("YEAR "  + year + "month " + month + "day " + day);

        let hours = parseInt(timeStr.substring(0, 2), 10);
        let minutes = parseInt(timeStr.substring(2, 4), 10);
        let seconds = parseInt(timeStr.substring(4, 6), 10);
    
    
        // Create a new date with the current date and the provided time
        let dateTime = new Date(year, month-1 , day, hours, minutes, seconds);
        console.log("JS Date time : " + dateTime.getTime());
        return dateTime;
    }
    
    function getEndTime(startTime, duration){

      console.log("StarTime"+startTime);
      console.log("duration: "+ duration);
      var newDate= new Date((startTime.getTime() + (duration*1000)));
      
      return newDate;
    
    }

    let formatedStartTime = (convertToDateTime(props.show.start_time, props.show.date));
    
    
    let options = { hour: '2-digit', minute: '2-digit', hour12: true };
    let timeString = formatedStartTime.toLocaleTimeString('en-US', options);
    let trimmedDescription = (props.show.description)
    
    let epTitle = props.show.title;
    let formatedEndTime = getEndTime(formatedStartTime, props.show.duration);
    console.log("end time : "+ formatedEndTime);
//check end time  and compare that to blackout

    /****
     * 
     * 
     */

    let newArray = props.blackoutData;
  //console.log(newArray);
  //let live = <a href="/live" className="watchNowButton">Watch Live</a>;
  let live = <a href="https://www.parrot.tv/?utm_source=CHCHCOM&utm_medium=Video&utm_campaign=CHCH_Player_Parrot&utm_id=CHCHCOM_Live_Stream&utm_content=Top_Bar#!/hero/parrot-chch
" target="_blank" className="watchNowButtonWrapperLink"><button className="watchNowButton" >Watch Live</button></a>;
  
  console.log(newArray);

  newArray.forEach((ele,index) => {
    
    let blackoutStart = new Date(ele['start']);
    let blackoutEnd = new Date(ele['end']);
    if(ele['countries'].length<=0){

      if(  blackoutStart <= formatedStartTime && formatedStartTime < blackoutEnd ){
        live = false;
        console.log(index);
        console.log("blackoutStart: "+ blackoutStart +"Shwo Start" +formatedStartTime);
        console.log("blackoutEnd: "+blackoutEnd + "Shwo END" +formatedEndTime);
      }
      console.log(index);
      console.log("blackoutStart: "+ blackoutStart +"Shwo Start" +formatedStartTime);
      console.log("blackoutEnd: "+blackoutEnd + "Shwo END" +formatedEndTime);
    }
  });
  var cc;var dvi;
  if(props.show.cc==="1"){
    cc = <img src="https://www.chch.com/wp-content/uploads/2024/08/cc_0.png" className="smallImages" />
  }
  
  if(props.show.dvi==="1"){
    dvi =  <img src="https://www.chch.com/wp-content/uploads/2025/03/Described_Video_Logo.png" className="smallImages describedVideoImage" /> 
  }
  /****
   * 
   * 
   */
    if( props.show.description===undefined){
        
        trimmedDescription ="";
    }
      return(
        <>
        
      <div className="mainPopUpCardContainer" >
        
      <div className="showWide">
        <div className="showColImage">
            <img className="showImage" src={props.show.thumbnail_path} />
        </div>
        <div className="showCol showDescripitionBox">  
            <h5 className="pop_card_ShowTime_Container">{timeString}</h5>
            <h4 className="pop_card_ShowTitle_Container">{epTitle}</h4>
            <p className="pop_card_ShowDescript_Container">{trimmedDescription}</p>
            <p className="ccImageContainer">
              {cc}<a className="dviImageContainer">{dvi}</a>
            </p>
            {live}
        </div>
       
        </div>
        </div>
        </>)
    
}

export default SelectedShow;